/**
 * 等待
 * @example
 * sleep(1000)
 */
export const sleep = (ms: number) => new Promise((res) => setTimeout(res, ms))
